import React from "react";
import ImgLazyLoad from "../ImgLazyLoad";

interface Props {
  selectedCars: any[];
  isPupopFromEmail?: boolean;
}
interface State {
  downloadMessage: string;
}

class BrochureDownloadPopup extends React.Component<Props, State> {
  static defaultProps = {
    isPupopFromEmail: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      downloadMessage: window["downloadMessage"],
    };
  }

  componentDidMount() {
    const overlay = document.querySelector(".custom-download-overlay") as any;
    const closeButton = document.querySelector(".custom-popup-exit");

    closeButton.addEventListener("click", function () {
      overlay.style.display = "none";
    });

    window.addEventListener("click", function (e) {
      if (e.target == overlay) {
        overlay.style.display = "none";
      }
    });

    window["pushDigitalData"](
      {
        event: "_formNavigate",
        form: {
          name: `download a brochure`,
          stage: `download available`,
        },
      },
      true
    );
  }

  render() {
    let downloadMessage = window["downloadMessage"];
    const downloadMessageOverrides = window["downloadMessageOverrides"];
    const messageOverrideForMultipleModel =
      window["messageOverrideForMultipleModel"];
    let carsWithOverrideMsg = [];
    let carText = "";
    downloadMessageOverrides.forEach((overrideItem) => {
      if (
        this.props.selectedCars.find(
          (x) => x.modelName === overrideItem.modelPicker
        )
      ) {
        carsWithOverrideMsg.push(overrideItem.modelPicker);
        if (this.props.selectedCars.length == 1) {
          downloadMessage = overrideItem.messageOverrideForSingleModel;
        } else {
          carText =
            carsWithOverrideMsg.slice(0, -1).join(", ") +
            (carsWithOverrideMsg.length > 1 ? " and " : "") +
            carsWithOverrideMsg.slice(-1);
          downloadMessage = messageOverrideForMultipleModel.replace(
            "[modelNames]",
            carText
          );
        }
      }
    });
    let customiseURL = "/configure";
    let testDriveURL = "/book-test-drive";
    let linkMessage =
      "Your brochures are available through the following links:";

    if (this.props.selectedCars.length == 1) {
      const car = this.props.selectedCars[0];
      const modelNameSlug = car.modelName.toLowerCase();
      testDriveURL = "/book-test-drive";
      customiseURL = "/configure";
      linkMessage = "Your brochure is available through the following link:";
    }

    linkMessage = this.props.isPupopFromEmail
      ? "Your brochure(s) are on their way but are also available below."
      : linkMessage;

    return (
      <div className="custom-download-popup">
        <span className="custom-popup-exit">&times;</span>
        <div className="custom-popup-container">
          <div className="download-container">
            <h2 className="download-thankyou-title">Thanks for downloading!</h2>
            <p className="custom-desktop-only">{linkMessage}</p>
            <div className="custom-popup-images">
              {this.props.selectedCars.map((car) => (
                <div key={car.modelName} className="each-cars">
                  <ImgLazyLoad src={car.carItem.firstElementChild.currentSrc} />
                  <a
                    className="btn--primary"
                    href={car.carItem.getAttribute("data-brochureLink")}
                    target="_blank"
                    onClick={() => {
                      window["pushDigitalData"](
                        {
                          event: "_formNavigate",
                          form: {
                            name: "download a brochure",
                            stage: "submitted",
                            details: {
                              vehicleSelected: [
                                {
                                  make: "subaru",
                                  model: car.modelName,
                                },
                              ],
                            },
                          },
                        },
                        true
                      );
                    }}
                  >
                    Download
                  </a>
                </div>
              ))}
            </div>
            <div className="download-message">
              <p>{downloadMessage}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BrochureDownloadPopup;
